import React from 'react';

import { getShopifyHost } from '@src/utils/shopify-host-redirect';
import styles from './simple-footer.module.scss';

const SimpleFooter: React.FC = () => {
  const shopifyHost = getShopifyHost();
  const baseUrl = shopifyHost || '';

  return (
    <footer className={styles.footer}>
      <ul className={styles.links}>
        <li>
          <a className={styles.link} href={`${baseUrl}/policies/terms-of-service`}>
            Terms
          </a>
        </li>
        <li className={styles.separator} />
        <li>
          <a className={styles.link} href={`${baseUrl}/policies/privacy-policy`}>
            Privacy
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default SimpleFooter;
